import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Holiday {
  id: number;
  approved: boolean;
  isRejected: boolean;
  isRequest: boolean;
  startDate: number;
  endDate: number;
  daysRequested: number;
  createdAt: string;
  partner?: {
    person?: {
      firstName?: string;
      lastName?: string;
      secondLastName?: string;
    };
  };
  reviewerBy?: {
    name?: string;
    lastName?: string;
  };
}

interface HolidaysState {
  holidays: Holiday[];
  total: number;
  page: number;
  limit: number;
  query: string;
  sortBy: string;
  defaultSort: string;
}

const initialState: HolidaysState = {
  holidays: [],
  total: 0,
  page: 0,
  limit: 10,
  query: '',
  sortBy: 'createdAt',
  defaultSort: 'desc',
};

const holidaysSlice = createSlice({
  name: 'holidays',
  initialState,
  reducers: {
    setHolidays: (state, action: PayloadAction<Holiday[]>) => {
      state.holidays = action.payload;
    },
    setTotal: (state, action: PayloadAction<number>) => {
      state.total = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setLimit: (state, action: PayloadAction<number>) => {
      state.limit = action.payload;
    },
    setQuery: (state, action: PayloadAction<string>) => {
      state.query = action.payload;
    },
    setSortBy: (state, action: PayloadAction<string>) => {
      state.sortBy = action.payload;
    },
    setDefaultSort: (state, action: PayloadAction<string>) => {
      state.defaultSort = action.payload;
    },
    resetHolidays: (state) => {
      state.holidays = [];
      state.total = 0;
      state.page = 0;
      state.query = '';
    },
  },
});

export const {
  setHolidays,
  setTotal,
  setPage,
  setLimit,
  setQuery,
  setSortBy,
  setDefaultSort,
  resetHolidays,
} = holidaysSlice.actions;

export default holidaysSlice.reducer;
